export const iconFontAwesomeConstructionBoreHole = (
	<i className="fa-solid fa-bore-hole"></i>
);
